import { find } from "@suse-o11y/find";
import { isPresent } from "@suse-o11y/is-present";
import { map } from "@suse-o11y/map";
import { pipe } from "@suse-o11y/pipe";
import { z } from "zod";

import { Api, type FullComponent } from "../common/openapi";

import ComponentData = Api.ComponentData;

const uidMetadataSchema = z
	.object({
		uid: z.string(),
	})
	.transform(({ uid }) => uid)
	.optional()
	.catch(undefined);

export const getPodUidFromComponent = ({ data, synced = [] }: FullComponent): undefined | string => {
	if (data.identifiers === undefined) {
		return undefined;
	}
	const kubernetesIdentifiers = data.identifiers.filter((identifier) => identifier.startsWith("urn:kubernetes:"));

	// the kubernetes stackpack is not active
	// so it is likely the component is created by another stackpack
	if (kubernetesIdentifiers.length === 0) {
		return undefined;
	}

	return pipe(
		synced,
		map((externalComponent) => {
			if (externalComponent.externalId != null && kubernetesIdentifiers.includes(externalComponent.externalId)) {
				return uidMetadataSchema.parse(externalComponent.sourceProperties?.metadata);
			}

			return undefined;
		}),
		find(isPresent),
	);
};
